// extracted by mini-css-extract-plugin
export default {"edit":"Edit_edit__-3ajQ","loader":"Edit_loader__1VNm8","editor":"Edit_editor__LOf6+"};